import jApi from './jApi';

export default {
  getListAi(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/ai/list', { params })
      .then(res => res);
  },

  getDetailAi(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/ai/detail', { params })
      .then(res => res);
  },

  createAi(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/ai/create', req)
      .then(res => res.data);
  },

  updateAi(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/ai/update', req)
      .then(res => res.data);
  },

  deleteAi(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/ai/delete', { params })
      .then(res => res.data);
  },

  trainAi(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/ai/train', req)
      .then(res => res.data);
  },

  getModelAi(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/ai/model', req)
      .then(res => res);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiAi.js